module.exports = __webpack_public_path__ + "img/album18_08.3dd55851.jpg";